import ReactDOMServer from "react-dom/server";
import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Marker = styled(CenteredFlexRow)`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${colorsPalettes.blue[400]};
`;

export const StyledAlertIcon = styled(SWReactIcons)`
    path {
        fill: white;
    }

    height: 12px;
    width: 12px;
`;

export default (changeStartDate: FixmeType, removeLine = false) => {
    return {
        xAxis: {
            plotLines: [
                {
                    color: "#7F8B97",
                    width: removeLine ? 0 : 1,
                    dashStyle: "Dash",
                    value: changeStartDate,
                    id: "plotLine-mw-algochange",
                    left: 11,
                    zIndex: 4,
                    label: {
                        text: ReactDOMServer.renderToString(
                            <Marker>
                                <StyledAlertIcon iconName="alerts" />
                            </Marker>,
                        ),
                        align: "right",
                        useHTML: true,
                        x: 10,
                        y: 0,
                        rotation: 0,
                        verticalAlign: "bottom",
                        className: "change-bell-without-tooltip",
                    },
                },
            ],
        },
    };
};
